import { render, staticRenderFns } from "./category-filter.vue?vue&type=template&id=ece926aa&scoped=true&"
import script from "./category-filter.vue?vue&type=script&lang=js&"
export * from "./category-filter.vue?vue&type=script&lang=js&"
import style0 from "./category-filter.vue?vue&type=style&index=0&id=ece926aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece926aa",
  null
  
)

export default component.exports